import styled from '@emotion/styled';

let fullWidth = parseInt(window.innerWidth);
if (fullWidth > 780) fullWidth = 640;
const ww86 = window.innerWidth < 360 ? fullWidth : parseInt(fullWidth * 0.86);

const W85 = `max-width: ${ww86}px; width:${ww86}px`;
const FW = `max-width: ${fullWidth}px; width:${fullWidth}px`;

export const DivW85 = styled.div`
    ${W85}
`;

export const PW85 = styled.p`
    ${W85}
`;

export const DivW = styled.div`
    ${FW}
`;
export const TableW = styled.table`
    ${FW}
`;

export const bps = {
    //@media screen and (min-width: 960px) {
    secreen960: '@media screen and (min-width: 960px)'
  }

export const MenuIz = styled.div`
    background-color: #fff;
    line-height: 15px;
    width: 100%;
    color: #535353;
`;

export const MenuIzTable = styled.table`
    width: 100%;

    tr {
        cursor: pointer;

        &.bo {
            border-bottom: 1px solid #cccccc;
        }
        &.nocursor {
            cursor: default;
        }
        &.nocursor:hover {
            background-color: transparent;
        }
        &.active,
        :hover {
            background-color: #e5e5e5;
        }

        td {
            height: 68px;

            :nth-of-type(1) {
                width: 53px;
                text-align: center;
            }
            :nth-of-type(2) {
                padding-right: 12px;
            }

            a {
                display: block;
                width: 100%;
                height: 68px;
                line-height: 68px;
                padding-left: 27px;
                text-decoration: none;
                color: #535353;
            }

            &.sim {
                text-align: left !important;
                padding-left: 27px;
            }
            &.nopad {
                padding: 0;
            }
            &.timen {
                letter-spacing: 4px !important;
                font-size: 12px !important;
                padding-left: 21px !important;
                color: #999 !important;
                height: 40px;
                background-color: #eeeeee;
            }
        }
    }
`;

export const MenuIzWrap = styled.div`
    height: 100%;
    overflow-y: auto;
}`;

export const MenuIzHead = styled.div`
    width: 100%;
    background-color: #00aae4;
    color: #fff;
    font-size: 15px;
    padding: 13px;

    p {
        margin: 9px 0 5px 0;
        line-height: 26px;
    }
}`;

export const MenuIzIndice = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    background-color: #eeeeee;
`;
const getItemIndiceStyles = ({styleParams}) => {
    const {activo, visto, n} = styleParams;

    let outStyle = '';

    switch (n) {
        case 1:
            outStyle += `font-weight: 900;
            border-bottom: 1px solid #c8c8c8;
            border-top: 1px solid #c8c8c8;`;
            break;
        case 2:
            outStyle += `position: relative;
            text-indent: 21px;

            :after {
                content: '';
                background-color: #009ddd;
                width: 13px;
                height: 2px;
                position: absolute;
                left: 30px;
                top: 21px;
            }`;
            break;
        case 3:
            outStyle += `position: relative;
            text-indent: 42px;
            
            :after {
                content: '';
                background-color: #ff6859;
                width: 13px;
                height: 2px;
                position: absolute;
                left: 54px;
                top: 21px;
            }`;
            break;

        default:
            break;
    }
    if (activo) {
        outStyle += `background-color: #e5e5e5;`;
    } else {
        outStyle += `cursor: pointer;
                    :hover {
                        background-color: #e5e5e5;
                    }`;
    }
    if (visto) {
        outStyle += `/* check.svg */
        background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIzMXB4IiBoZWlnaHQ9IjEycHgiIHZpZXdCb3g9IjAgMCAzMSAxMiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMzEgMTIiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGc+DQoJCTxwb2x5Z29uIGZpbGw9IiMyN0FFNjAiIHBvaW50cz0iMTMuNjIyLDAgNC45MzIsNy45MjkgMS4yNzMsNC4yOTMgMCw1LjU2NiA1LjAxOSwxMC41NzEgMTUsMS4zNDkgCQkiLz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg==);`;
    } else {
        outStyle += `/* item.svg */
        background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIzMS4wNTNweCIgaGVpZ2h0PSIxMS40ODJweCIgdmlld0JveD0iMCAwIDMxLjA1MyAxMS40ODIiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMxLjA1MyAxMS40ODIiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHJlY3QgeD0iMCIgeT0iNSIgZmlsbD0iI0M0QzRDNCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjIiLz4NCjwvc3ZnPg0K);`;
    }
    return outStyle;
};

export const MenuIzIndiceItem = styled.li`
    display: block;
    width: 100%;
    padding: 12px 10px 12px 36px;
    color: #535353;
    margin-bottom: -1px;
    background-repeat: no-repeat;
    background-position: right center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    ${getItemIndiceStyles}

`;

const getImageDisabled = props => {
    if(props.styleLoading){
        return `opacity: 0.4;`
    }else{
        return `opacity: 1`
    }

}

const getBgDisabled = props => {
    if(props.styleLoading){
        return `background-color: rgb(0, 170, 228, 0.8);
        background-image: none !important;
        cursor: default;`
    }else{
        return `background-color: #00aae4;
        background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIyMS4zMzZweCIgaGVpZ2h0PSIxNi41N3B4IiB2aWV3Qm94PSIwIDAgMjEuMzM2IDE2LjU3IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMS4zMzYgMTYuNTciIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik04LjE3NiwwLjY2NEgtNC4yN2MtMC40NywwLTAuODUxLDAuMzgxLTAuODUxLDAuODU0YzAsMC40NywwLjM4MSwwLjg1MSwwLjg1MSwwLjg1MUg4LjE3Ng0KCQkJYzAuNDcxLTAuMDAxLDAuODUyLTAuMzgyLDAuODUyLTAuODUyQzkuMDI4LDEuMDQ1LDguNjQ3LDAuNjY0LDguMTc2LDAuNjY0eiIvPg0KCQk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNOC4xNzYsNy4xNzZILTQuMjdjLTAuNDcsMC0wLjg1MSwwLjM4Mi0wLjg1MSwwLjg1M1MtNC43NCw4Ljg3OS00LjI3LDguODc5SDguMTc2DQoJCQljMC40NzEsMCwwLjg1Mi0wLjM4LDAuODUyLTAuODUxUzguNjQ3LDcuMTc2LDguMTc2LDcuMTc2eiIvPg0KCQk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNOC4xNzYsMTMuNjg2SC00LjI3Yy0wLjQ3LDAtMC44NTEsMC4zODEtMC44NTEsMC44NTJjMCwwLjQ3LDAuMzgxLDAuODUzLDAuODUxLDAuODUzSDguMTc2DQoJCQljMC40NzEsMCwwLjg1Mi0wLjM4MywwLjg1Mi0wLjg1M0M5LjAyOCwxNC4wNjcsOC42NDcsMTMuNjg2LDguMTc2LDEzLjY4NnoiLz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg==);
        cursor: pointer;`
    }

}

export const HeaderLogo = styled.div`
    
    text-align: center;
    padding-left: 10px;

    background-repeat: no-repeat;
    background-position: 0 20px;
    width: 58px;
    height: 52px;
    position: absolute;

    ${getBgDisabled}

    img{
        margin-top: 20px;

        &.ieslogo {
            max-width: 32px;
            margin-top: 21px;
        }
        ${getImageDisabled}
    }
    
`

const getPaddingH1 = props => {
    const {showPreguntasBtn, showUtilsBtn} = props.styleParams;
    if (showPreguntasBtn && showUtilsBtn) {
        return 'padding-right:140px';
    } else if (showPreguntasBtn || showUtilsBtn) {
        return 'padding-right:90px';
    } else {
        return 'padding-right:60px';
    }
};

export const HeaderCont = styled.header`

    background-color: #009ddd;
	width: 100%;
	position: fixed;
	height: 52px;
	top: 0;
    z-index: 1300;
    
    background-color: #fff;
    border-bottom: 1px solid #ccc;

    h1 {
        color: #535353;
        text-align: left;
        font-weight: 400;
        margin: 0;
        height: 52px;
        line-height: 52px;
        font-size: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-left: 68px;
        ${getPaddingH1}
    }

    
`
export const HeaderTopButtons = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    display: flex;

    div {
        display: inline-flex;
    }

    div.preguntas {
        width: 46px;
        height: 52px;
        /* preguntas.svg */
        background-image: url(data:image/svg+xml;base64,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);
        background-repeat: no-repeat;
        background-position: center center;
        cursor: pointer;
        background-size: 24px;
    }

    div.menu {
        width: 46px;
        height: 52px;
        /* menu.svg */
        background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIyMS4zMzZweCIgaGVpZ2h0PSIxNi41N3B4IiB2aWV3Qm94PSIwIDAgMjEuMzM2IDE2LjU3IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMS4zMzYgMTYuNTciIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGZpbGw9IiM1MzUzNTMiIGQ9Ik0xOC4xNDgsMC42NjRINS43MDJjLTAuNDcsMC0wLjg1MSwwLjM4MS0wLjg1MSwwLjg1M2MwLDAuNDcsMC4zODEsMC44NTEsMC44NTEsMC44NTFoMTIuNDQ2DQoJCQlDMTguNjE5LDIuMzY3LDE5LDEuOTg2LDE5LDEuNTE2QzE5LDEuMDQ1LDE4LjYxOSwwLjY2NCwxOC4xNDgsMC42NjR6Ii8+DQoJCTxwYXRoIGZpbGw9IiM1MzUzNTMiIGQ9Ik0xOC4xNDgsNy4xNzZINS43MDJjLTAuNDcsMC0wLjg1MSwwLjM4MS0wLjg1MSwwLjg1MnMwLjM4MSwwLjg1MSwwLjg1MSwwLjg1MWgxMi40NDYNCgkJCWMwLjQ3MSwwLDAuODUyLTAuMzgsMC44NTItMC44NTFTMTguNjE5LDcuMTc2LDE4LjE0OCw3LjE3NnoiLz4NCgkJPHBhdGggZmlsbD0iIzUzNTM1MyIgZD0iTTE4LjE0OCwxMy42ODZINS43MDJjLTAuNDcsMC0wLjg1MSwwLjM4MS0wLjg1MSwwLjg1MmMwLDAuNDcsMC4zODEsMC44NTIsMC44NTEsMC44NTJoMTIuNDQ2DQoJCQljMC40NzEsMCwwLjg1Mi0wLjM4MiwwLjg1Mi0wLjg1MkMxOSwxNC4wNjcsMTguNjE5LDEzLjY4NiwxOC4xNDgsMTMuNjg2eiIvPg0KCTwvZz4NCgk8Y2lyY2xlIGZpbGw9IiM1MzUzNTMiIGN4PSIxLjQ3IiBjeT0iMS40NjkiIHI9IjEuNDciLz4NCgk8Y2lyY2xlIGZpbGw9IiM1MzUzNTMiIGN4PSIxLjQ3IiBjeT0iNy45ODUiIHI9IjEuNDciLz4NCgk8Y2lyY2xlIGZpbGw9IiM1MzUzNTMiIGN4PSIxLjQ3IiBjeT0iMTQuNTAxIiByPSIxLjQ3Ii8+DQo8L2c+DQo8L3N2Zz4NCg==);
        background-repeat: no-repeat;
        background-position: center center;
        cursor: pointer;
    }
`

export const HeaderInputSearch = styled.input`
    width: 200px;
    display: inline-flex;
    position: absolute;
    right: 43px;
    top: 9px;

    border: 1px solid #ccc;
    background-color: #fff;
    color: #666;
    font-size: 11px;
    text-align: left;
    text-indent: 16px;
    height: 35px;
    /* serach-bg.svg */
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIzOC43NzFweCIgaGVpZ2h0PSIzOC4xMzVweCIgdmlld0JveD0iMCAwIDM4Ljc3MSAzOC4xMzUiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDM4Ljc3MSAzOC4xMzUiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggZmlsbD0iI0EyQTJBMiIgZD0iTTI1LjY5MywyMy44NDRsLTMuMzAyLTMuMzc5YzAuNjMtMC43NjMsMS4wMTItMS43NDYsMS4wMTItMi44MmMwLTIuNDA4LTEuOTE1LTQuMzctNC4yNjktNC4zNw0KCWMtMi4zNTQsMC4wMDEtNC4yNywxLjk2Mi00LjI3LDQuMzcxczEuOTE2LDQuMzcsNC4yNyw0LjM3YzAuODg2LDAsMS43MDctMC4yNzcsMi4zOTEtMC43NTJsMy4zNDUsMy40MjMNCgljMC4xMTMsMC4xMTYsMC4yNjQsMC4xNzUsMC40MTMsMC4xNzVjMC4xNDgsMCwwLjI5Ny0wLjA1OSwwLjQxLTAuMTc1QzI1LjkyMywyNC40NTUsMjUuOTIzLDI0LjA3NiwyNS42OTMsMjMuODQ0eiBNMTYuMDI5LDE3LjY0NQ0KCWMwLTEuNzUzLDEuMzkzLTMuMTc5LDMuMTA1LTMuMTc5czMuMTA0LDEuNDI2LDMuMTA0LDMuMTc5cy0xLjM5MSwzLjE3OC0zLjEwNCwzLjE3OFMxNi4wMjksMTkuMzk3LDE2LjAyOSwxNy42NDV6Ii8+DQo8L3N2Zz4NCg==);
    background-position: left center;
    background-repeat: no-repeat;

    ::-webkit-input-placeholder {
        text-align: left;
    }
    ::-moz-placeholder {
        text-align: left;
    }
    :-ms-input-placeholder {
        text-align: left;
    }
    :-moz-placeholder {
        text-align: left;
    }
`
const getClassSearchBtn = ({uv, vs}) => {
    let clase = ``;
    if(uv) {
        clase += `  opacity: 0.5; 
                    cursor: default;`
    }else{
        clase += `  opacity: 1;
                    cursor: pointer;`
    }
    if(vs) {
        clase +=  `background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIxNi45NzRweCIgaGVpZ2h0PSIxNy4wNDlweCIgdmlld0JveD0iMCAwIDE2Ljk3NCAxNy4wNDkiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDE2Ljk3NCAxNy4wNDkiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGxpbmUgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2NjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiB4MT0iMiIgeTE9IjIiIHgyPSIxNC43MjciIHkyPSIxNC43MjYiLz4NCjxsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzY2NjY2NiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgeDE9IjE0LjcyNyIgeTE9IjIiIHgyPSIyIiB5Mj0iMTQuNzI2Ii8+DQo8L3N2Zz4NCg==');`
    }else{
        clase +=  `background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIxNS43M3B4IiBoZWlnaHQ9IjE2LjU3cHgiIHZpZXdCb3g9IjAgMCAxNS43MyAxNi41NyIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTUuNzMgMTYuNTciIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggZmlsbD0iIzUzNTM1MyIgZD0iTTE1LjQ4NiwxNS4xMTVsLTQuNzIzLTQuODM0YzAuOTAxLTEuMDksMS40NDgtMi40OTUsMS40NDgtNC4wMzJjMC0zLjQ0NC0yLjczOS02LjI1LTYuMTA1LTYuMjUNCglDMi43MzksMCwwLDIuODA0LDAsNi4yNWMwLDMuNDQ2LDIuNzM5LDYuMjUsNi4xMDYsNi4yNWMxLjI2NywwLDIuNDQyLTAuMzk2LDMuNDE5LTEuMDc2bDQuNzgzLDQuODk2DQoJYzAuMTYyLDAuMTY2LDAuMzc3LDAuMjUsMC41OSwwLjI1czAuNDI2LTAuMDg0LDAuNTg4LTAuMjVDMTUuODEzLDE1Ljk4OCwxNS44MTMsMTUuNDQ3LDE1LjQ4NiwxNS4xMTV6IE0xLjY2NSw2LjI1DQoJYzAtMi41MDYsMS45OTItNC41NDUsNC40NDEtNC41NDVzNC40MzksMi4wMzksNC40MzksNC41NDVjMCwyLjUwNy0xLjk5MSw0LjU0NS00LjQzOSw0LjU0NUMzLjY1NywxMC43OTUsMS42NjUsOC43NTYsMS42NjUsNi4yNXoiDQoJLz4NCjwvc3ZnPg0K);`
    }

    return clase;
}

export const HeaderSearchBtn = styled.div`
    width: 46px;
    height: 52px;
    
    background-repeat: no-repeat;
    background-position: center center;

    ${getClassSearchBtn}
`